import { Component, OnInit } from '@angular/core';
import { IframeCommunicationService } from '../../../services/iframe-communication.service';
import {InternalConfigService} from '../../../services/internal-config.service';

@Component({
  selector: 'app-additional-content-section',
  templateUrl: './additional-content-section.component.html',
  styleUrls: ['./additional-content-section.component.scss']
})
export class AdditionalContentSectionComponent implements OnInit {

  sectionVisible: boolean;
  contentExpanded = true;
  expandButtonVisible = true;
  readonly SECTION_BEFORE_EXPAND_INDEX = 0;

  config: ArticleConfig;
  ContentType = ArticleSectionContentType;

  private readonly translationContainerKey = 'ADDITIONAL_CONTENT_SECTION';

  constructor(private iframeService: IframeCommunicationService,
              private internalConfigService: InternalConfigService) { }

  ngOnInit() {
    this.createConfig();
    this.initSectionVisible();
  }

  toggleExpanded(): void {
    this.contentExpanded = !this.contentExpanded;
    if (!this.contentExpanded) {
      this.iframeService.forceResize();
    }
  }

  isSectionHidden(index: number): boolean {
    return !this.contentExpanded && index !== this.SECTION_BEFORE_EXPAND_INDEX;
  }

  private initSectionVisible(): void {
    this.sectionVisible = this.internalConfigService.resolveSectionVisibility('aztecSection');
  }

  private createConfig(): void {
    this.config = {
      sections: [
        {
          contents: [
            {
              type: ArticleSectionContentType.HEADING_2,
              content: `${this.translationContainerKey}.title`,
              cssClass: 'font-normal'
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.paragraph1`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.paragraph2`
            }
          ]
        },
        {
          contents: [
            {
              type: ArticleSectionContentType.HEADING_2,
              content: `${this.translationContainerKey}.SECTION_1.title`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_1.paragraph1`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_1.paragraph2`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_1.paragraph3`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_1.paragraph4`
            }
          ]
        },
        {
          contents: [
            {
              type: ArticleSectionContentType.HEADING_2,
              content: `${this.translationContainerKey}.SECTION_2.title`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_2.paragraph1`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_2.paragraph2`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_2.paragraph3`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_2.paragraph4`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_2.paragraph5`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_2.paragraph6`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_2.paragraph7`
            }
          ]
        },
        {
          contents: [
            {
              type: ArticleSectionContentType.HEADING_2,
              content: `${this.translationContainerKey}.SECTION_3.title`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_3.paragraph1`
            }
          ]
        },
        {
          contents: [
            {
              type: ArticleSectionContentType.HEADING_2,
              content: `${this.translationContainerKey}.SECTION_4.title`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_4.paragraph1`
            }
          ]
        },
        {
          contents: [
            {
              type: ArticleSectionContentType.HEADING_2,
              content: `${this.translationContainerKey}.SECTION_5.title`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_5.paragraph1`
            }
          ]
        },
        {
          contents: [
            {
              type: ArticleSectionContentType.HEADING_2,
              content: `${this.translationContainerKey}.SECTION_6.title`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_6.paragraph1`
            }
          ]
        },
        {
          contents: [
            {
              type: ArticleSectionContentType.HEADING_2,
              content: `${this.translationContainerKey}.SECTION_7.title`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_7.paragraph1`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_7.paragraph2`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_7.paragraph3`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_7.paragraph4`
            }
          ]
        },
        {
          contents: [
            {
              type: ArticleSectionContentType.HEADING_2,
              content: `${this.translationContainerKey}.SECTION_8.title`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_8.paragraph1`
            }
          ]
        },
        {
          contents: [
            {
              type: ArticleSectionContentType.HEADING_2,
              content: `${this.translationContainerKey}.SECTION_9.title`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_9.paragraph1`
            }
          ]
        },
        {
          contents: [
            {
              type: ArticleSectionContentType.HEADING_2,
              content: `${this.translationContainerKey}.SECTION_10.title`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_10.paragraph1`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_10.paragraph2`
            }
          ]
        },
        {
          contents: [
            {
              type: ArticleSectionContentType.HEADING_2,
              content: `${this.translationContainerKey}.SECTION_11.title`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_11.paragraph1`
            }
          ]
        },
        {
          contents: [
            {
              type: ArticleSectionContentType.HEADING_2,
              content: `${this.translationContainerKey}.SECTION_12.title`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_12.paragraph1`
            }
          ]
        },
        {
          contents: [
            {
              type: ArticleSectionContentType.HEADING_2,
              content: `${this.translationContainerKey}.SECTION_13.title`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_13.paragraph1`
            }
          ]
        },
        {
          contents: [
            {
              type: ArticleSectionContentType.HEADING_2,
              content: `${this.translationContainerKey}.SECTION_14.title`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_14.paragraph1`
            }
          ]
        },
        {
          contents: [
            {
              type: ArticleSectionContentType.HEADING_2,
              content: `${this.translationContainerKey}.SECTION_15.title`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_15.paragraph1`
            }
          ]
        },
        {
          contents: [
            {
              type: ArticleSectionContentType.HEADING_2,
              content: `${this.translationContainerKey}.SECTION_16.title`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_16.paragraph1`
            }
          ]
        },
        {
          contents: [
            {
              type: ArticleSectionContentType.HEADING_2,
              content: `${this.translationContainerKey}.SECTION_17.title`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_17.paragraph1`
            }
          ]
        },
        {
          contents: [
            {
              type: ArticleSectionContentType.HEADING_2,
              content: `${this.translationContainerKey}.SECTION_18.title`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_18.paragraph1`
            }
          ]
        },
        {
          contents: [
            {
              type: ArticleSectionContentType.HEADING_2,
              content: `${this.translationContainerKey}.SECTION_19.title`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_19.paragraph1`
            }
          ]
        },
        {
          contents: [
            {
              type: ArticleSectionContentType.HEADING_2,
              content: `${this.translationContainerKey}.SECTION_20.title`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_20.paragraph1`
            }
          ]
        },
        {
          contents: [
            {
              type: ArticleSectionContentType.HEADING_2,
              content: `${this.translationContainerKey}.SECTION_21.title`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_21.paragraph1`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_21.paragraph2`,
              cssClass: 'bold'
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_21.paragraph3`
            }
          ]
        },
        {
          contents: [
            {
              type: ArticleSectionContentType.HEADING_2,
              content: `${this.translationContainerKey}.SECTION_22.title`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_22.paragraph1`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_22.paragraph2`
            }
          ]
        },
        {
          contents: [
            {
              type: ArticleSectionContentType.HEADING_2,
              content: `${this.translationContainerKey}.SECTION_23.title`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_23.paragraph1`
            }
          ]
        },
        {
          contents: [
            {
              type: ArticleSectionContentType.HEADING_2,
              content: `${this.translationContainerKey}.SECTION_24.title`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_24.paragraph1`
            },
            {
              type: ArticleSectionContentType.ORDERED_LIST,
              content: `${this.translationContainerKey}.SECTION_24.list1`
            }
          ]
        },
        {
          contents: [
            {
              type: ArticleSectionContentType.HEADING_2,
              content: `${this.translationContainerKey}.SECTION_25.title`
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_25.paragraph1Heading`,
              cssClass: 'bold additional-section__paragraph-heading'
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_25.paragraph1Content`,
              cssClass: 'additional-section__paragraph-content'
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_25.paragraph2Heading`,
              cssClass: 'bold additional-section__paragraph-heading'
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_25.paragraph2Content`,
              cssClass: 'additional-section__paragraph-content'
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_25.paragraph3Heading`,
              cssClass: 'bold additional-section__paragraph-heading'
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_25.paragraph3Content`,
              cssClass: 'additional-section__paragraph-content'
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_25.paragraph4Heading`,
              cssClass: 'bold additional-section__paragraph-heading'
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_25.paragraph4Content`,
              cssClass: 'additional-section__paragraph-content'
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_25.paragraph5Heading`,
              cssClass: 'bold additional-section__paragraph-heading'
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_25.paragraph5Content`,
              cssClass: 'additional-section__paragraph-content'
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_25.paragraph6Heading`,
              cssClass: 'bold additional-section__paragraph-heading'
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_25.paragraph6Content`,
              cssClass: 'additional-section__paragraph-content'
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_25.paragraph7Heading`,
              cssClass: 'bold additional-section__paragraph-heading'
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_25.paragraph7Content`,
              cssClass: 'additional-section__paragraph-content'
            },
            {
              type: ArticleSectionContentType.PARAGRAPH,
              content: `${this.translationContainerKey}.SECTION_25.paragraph8`
            }
          ]
        }
      ]
    }
  }

}

export interface ArticleConfig {
  sections: ArticleSection[];
}

export interface ArticleSection {
  contents: ArticleSectionContent[];
  cssClass?: string;
}

export interface ArticleSectionContent {
  type: ArticleSectionContentType;
  content: string;
  cssClass?: string;
}

export enum ArticleSectionContentType {
  PARAGRAPH = 'PARAGRAPH',
  LIST = 'LIST',
  ORDERED_LIST = 'ORDERED_LIST',
  TABLE = 'TABLE',
  HEADING_1 = 'HEADING_1',
  HEADING_2 = 'HEADING_2',
  HEADING_3 = 'HEADING_3',
}
